(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-announcement"]) return;
  try {
    
  (function () {
    function initializeBar(bar) {
      if (bar.dataset.grayishInitialized === 'true') {
        if (typeof bar.grayishAnnouncementStart === 'function') {
          bar.grayishAnnouncementStart();
        }
        return;
      }
      bar.dataset.grayishInitialized = 'true';

      var messages = Array.prototype.slice.call(
        bar.querySelectorAll('[data-announcement-message]')
      );
      var previous = bar.querySelector('[data-announcement-previous]');
      var next = bar.querySelector('[data-announcement-next]');
      var configuredSeconds = parseInt(bar.dataset.rotationSeconds, 10) || 4;
      var seconds = Math.min(Math.max(configuredSeconds, 3), 4);
      var current = 0;
      var timer;
      var cycleToken = 0;

      if (messages.length < 2) {
        if (previous) previous.hidden = true;
        if (next) next.hidden = true;
        return;
      }

      function show(index) {
        current = (index + messages.length) % messages.length;
        messages.forEach(function (message, messageIndex) {
          message.hidden = messageIndex !== current;
        });
      }

      function stop() {
        cycleToken += 1;
        window.clearTimeout(timer);
      }

      function start() {
        stop();
        if (document.hidden) return;

        var activeCycle = cycleToken;

        function scheduleNext() {
          timer = window.setTimeout(function () {
            if (activeCycle !== cycleToken) return;
            show(current + 1);
            scheduleNext();
          }, seconds * 1000);
        }

        scheduleNext();
      }

      bar.grayishAnnouncementStart = start;

      previous.addEventListener('click', function () {
        show(current - 1);
        start();
      });

      next.addEventListener('click', function () {
        show(current + 1);
        start();
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });

      show(0);
      start();
    }

    function initializeAnnouncements(scope) {
      var root = scope || document;
      var bars = [];

      if (root.matches && root.matches('[data-grayish-announcement]')) {
        bars.push(root);
      }

      if (root.querySelectorAll) {
        bars = bars.concat(
          Array.prototype.slice.call(
            root.querySelectorAll('[data-grayish-announcement]')
          )
        );
      }

      bars.forEach(initializeBar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAnnouncements(document);
      }, { once: true });
    } else {
      initializeAnnouncements(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAnnouncements(event.target);
    });

    window.addEventListener('pageshow', function () {
      initializeAnnouncements(document);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
